import React, { useRef, useState } from 'react'
import { useApplicationContext } from '../../contexts/appContext'
import { ErrorDialog, LoadingDialog, Header, Layout } from '@verifier-user/verifier-cdr'
import { EastVenturesError } from './EastVenturesError'
import { EnergyError } from './EnergyError'
import { IncomeError } from './IncomeError'
import { BavError } from './BavError'

export const Error = () => {
  const [error, setError] = useState(null)
  const [errorShown, setErrorShown] = useState(false)
  const [processing, setProcessing] = useState(false)
  const containerRef = useRef(null)
  const currentErrorRef = useRef(null)

  const { vendorSettings, vendorData, logout } = useApplicationContext()

  const components = {
    EastVenturesError,
    IncomeError,
    EnergyError,
    BavError
  }

  const getErrorComponent = () => {
    const ErrorComponent = components[vendorData.errorComponent]
    return (
      <ErrorComponent
        currentErrorRef={currentErrorRef}
        setProcessing={setProcessing}
        setError={setError}
        setErrorShown={setErrorShown}
      />
    )
  }

  return (
    <>
      <Header vendorSettings={vendorSettings} />
      <Layout
        vendorSettings={vendorSettings}
        isAuthenticated={() => {
          return false
        }}
        logout={logout}
      >
        <div ref={containerRef}>
          <LoadingDialog id={'fnf-error'} isOpen={processing} />
          {error && (
            <ErrorDialog
              id='errorDialog'
              error={error}
              open={errorShown}
              setOpen={setErrorShown}
              cancelHandler={currentErrorRef.current && currentErrorRef.current.cancelFunction}
              okTitle={
                currentErrorRef.current && currentErrorRef.current.okTitle ? currentErrorRef.current.okTitle : 'Ok'
              }
              cancelTitle={
                currentErrorRef.current && currentErrorRef.current.cancelTitle
                  ? currentErrorRef.current.cancelTitle
                  : 'Cancel'
              }
              retryHandler={currentErrorRef.current ? currentErrorRef.current.retryFunction : undefined}
            />
          )}

          {getErrorComponent()}
        </div>
      </Layout>
    </>
  )
}
